export default "__VITE_ASSET__PuK2g4Rz__"